import React from "react";

const Cotton = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Cotton</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg table-responsive"
        style={{ textAlign: "justify" }}
      >
        <table className="table table-striped table-bordered">
          <thead className="text-center">
            <tr>
              <th>Seed Rate</th>
              <th>Sowing Time</th>
              <th>Irrigation</th>
              <th>Maturity Time</th>
              <th>Characterstics</th>
              <th>Average Yield</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="6">
                <strong>HD - 123 [Released in 03.04.2000]</strong>
              </td>
            </tr>
            <tr>
              <td>6-8 kgs per acre.</td>
              <td>Suitable for early sowing; till 15th-20th May</td>
              <td>
                3-4 irrigations. First time to be done a while after sowing. And
                last to be done when the buds are 1/3rd opened.
              </td>
              <td>165-175 days. Last picking ends by mid October.</td>
              <td>
                Flowers are small in size with white petals, and the buds are
                round. Plant height is approximately 150 cm.
              </td>
              <td>8 quintals per acre.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>H - 1117 [Released in 04.09.2002]</strong>
              </td>
            </tr>
            <tr>
              <td>6-8 kgs per acre.</td>
              <td>
                Suitable for early as well as timely sowing; till 15th May.
              </td>
              <td>
                3-4 irrigations. First time to be done a while after sowing. And
                last to be done when the buds are 1/3rd opened.
              </td>
              <td>170-175 days.</td>
              <td>
                Straight plant with 2-3 strong branches and small, green leaves.
                Buds are round and medium sized with cream coloured flowers.
                Suitable to Haryana.
              </td>
              <td>8-9 quintals per acre, but can give upto 15 quintals.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>H - 1098 [Released in 01.05.1997]</strong>
              </td>
            </tr>
            <tr>
              <td>6-8 kgs per acre.</td>
              <td>Suitable to late sowing; 15th May to first week of June.</td>
              <td>
                3-4 irrigation. First time to be done a while after sowing. And
                last to be done when the buds are 1/3rd opened.
              </td>
              <td>165 days.</td>
              <td>
                Plants grow straight and upto 130 cm high. Buds are midium sized
                and sharp with cream coloured flowers. Appropriate for the wheat
                crop cycle. Fibre is upto 22.7 cm long and cotton wool is upto
                35.2%. Resistant to tela and caterpillers.
              </td>
              <td>7-8 quintals per acre.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>F - 1861 [Released in 12.03.2003]</strong>
              </td>
            </tr>
            <tr>
              <td>6-8 kgs per acre.</td>
              <td>Suitable to be sown in May.</td>
              <td>
                3-4 irrigations. First time to be done a while after sowing. And
                last to be done when the buds are 1/3rd opened.
              </td>
              <td>180 days.</td>
              <td>
                Appropriate for irrigated area. This is a high yielding variety
                and is resistant to leaf curl disease. Suitable for Punjab.
                Plant height is around 135 cm. Fiber is of medium length.
              </td>
              <td>8 quintals per acre.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>H - 1226 [Released in 20.07.2007]</strong>
              </td>
            </tr>
            <tr>
              <td>6-8 kgs per acre.</td>
              <td>Suitable to be sown in May.</td>
              <td>
                3-4 irrigations. First time to be done a while after sowing. And
                last to be done when the buds are 1/3rd opened.
              </td>
              <td>170-175 days.</td>
              <td>
                Plant height is around 160 cm. It is resistant to leaf curl
                disease. Suitable for the irrigated areas of Haryana. Covering
                of the buds is hard and the cotton wool is of good quality.
              </td>
              <td>9-10 quintals per acre.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Cotton;
